import { useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { getSaleUnitPluralNoun } from 'hooks/useSaleUnitPlural'

interface Props {
  saleUnit: string
}

function PreSelectionBanner({ saleUnit }: Props) {
  const intl = useIntl()
  return (
    <MessageBanner
      kind="promotional-primary"
      density="compact"
    >
      {intl.formatMessage(
        {
          id: 'VlZDqde2ceMwvtQv4flm',
          defaultMessage: 'We’ve pre-selected the best-value {pluralSaleUnit} to get you started. Customise each {saleUnit} below.',
          description: 'Banner message explaining auto-selected best-value room packages',
        },
        { pluralSaleUnit: getSaleUnitPluralNoun(saleUnit), saleUnit },
      )}
    </MessageBanner>
  )
}

export default PreSelectionBanner
